import React, { useEffect, useState } from 'react';
import ENV from '../../env.json';
import axios from 'axios';
import imageNotFound from '../../assets/images/image-not-found.svg';
import Button from '../../components/button/button.index';
import MovieCard from '../../components/movieCard/movieCard.index';
import { CastType, MovieType } from '../WOM.interface';
import { errorMessages, WOMAPI } from '../WOM.api';
import { useParams, useHistory } from 'react-router';
import { toast } from 'react-toastify';
import { makeApiUrl, responseValidator } from '../../scripts/functions';
import { LazyImage } from 'react-lazy-images';
import "./person.style.scss"


const Person: React.FC = () => {
    const [person, setPerson] = useState<CastType | undefined>(undefined);
    const [movies, setMovies] = useState<MovieType[] | undefined>(undefined); 
    const params: { id: string } = useParams();
    const history = useHistory();

    useEffect(() => {
        axios.get<CastType>(makeApiUrl(WOMAPI.person(Number(params.id)))) .then((response) => {
            if (responseValidator(response)) {
                setPerson(response.data);
            } else {
                toast.error(errorMessages.APIError);
            }
        }).catch(() => {
            toast.error(errorMessages.APIError);
        });
        axios.get(makeApiUrl(WOMAPI.discover, `with_cast=${params.id}`)).then((response) => {
            if (responseValidator(response)) {
                setMovies(response.data.results);
            } else {
                toast.error(errorMessages.APIError);
            }
        }).catch(() => {
            toast.error(errorMessages.APIError);
        });
    }, []);

    return (
        <div className="wom-person">
            {person && movies ? (
                <>
                    <div className="content">
                        <div className="person-profile">
                            <LazyImage
                                src={person.profile_path ? ENV.TMDB_IMAGE + person.profile_path: imageNotFound}
                                placeholder={({ imageProps, ref }) => (
                                    <div className="isLoading" ref={ref}>
                                        <div className="loader poster-loader">
                                            Loading ...
                                        </div>
                                    </div>
                                )}
                                actual={({ imageProps }) => <img {...imageProps} />}
                            >
                                <img
                                    src={person.profile_path ? ENV.TMDB_IMAGE + person.profile_path : imageNotFound}
                                    alt={person.name}
                                />
                            </LazyImage>
                        </div>
                        <div className="person-detail">
                            <h3>{person.name}</h3>
                            <small>{person.birthday} {person.deathday && " - " + person.deathday} {person.place_of_birth && ' | ' + person.place_of_birth}</small>
                            <p>{person.biography ? person.biography : 'There is no biography !'}</p>
                            <div className="buttons">
                                <Button onClick={() => history.goBack()}>
                                    Back
                                </Button>
                            </div>
                        </div>
                    </div>
                    {movies ? (
                        movies.length ? (
                            <div className="recommendations">
                                <h3>Also enters in</h3>
                                <div className="movie-list">
                                    {movies.map((movie) => (
                                        <MovieCard movie={movie} />
                                    ))}
                                    <div className="grid-protector"></div>
                                    <div className="grid-protector"></div>
                                    <div className="grid-protector"></div>
                                    <div className="grid-protector"></div>
                                    <div className="grid-protector"></div>
                                    <div className="grid-protector"></div>
                                </div>
                            </div>
                        ) : null
                    ) : null}
                </>
            ) : (
                <div className="movie-loader">
                    <div className="loader">Loading  ...</div>
                </div>
            )}
        </div>
    );
};

export default Person;
